import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import Alert from "shared/components/Alert";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const Consents = ({ setPercent, initialValues, bindField }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  const acceptContactPath = "project.contact.acceptContact";
  const acceptContactLabel =
    SUBSCRIPTION.FORM.DIGITAL_OPTION.INFO_LMF_CONTACT;
  const acceptContactField = bindField(acceptContactPath, {
    label: acceptContactLabel,
    onChange: () => setPercent(initialValues),
  });

  const acceptDigitalPath = "project.contact.acceptDigital";
  const acceptDigitalLabel =
    SUBSCRIPTION.FORM.DIGITAL_OPTION.INFO_LMF_MAIL_ME;
  const acceptDigitalField = bindField(acceptDigitalPath, {
    label: acceptDigitalLabel,
    onChange: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.CONSENTS}-section`}
    >
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.CONSENTS.TITLE}
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={acceptContactField.path}
              label={acceptContactField.label}
              required={acceptContactField.required}
              disabled={acceptContactField.disabled}
            >
              {(field) => (
                <Input
                  type="switch"
                  label={acceptContactLabel}
                  checked={get(initialValues, acceptContactPath) === true}
                  {...field}
                  onChange={acceptContactField.onChange}
                  onBlur={acceptContactField.onBlur}
                />
              )}
            </FormField>
          </Col>
          <Col lg={24} xs={24}>
            <FormField
              path={acceptDigitalField.path}
              label={acceptDigitalField.label}
              required={acceptDigitalField.required}
              disabled={acceptDigitalField.disabled}
            >
              {(field) => (
                <Input
                  type="switch"
                  label={acceptDigitalLabel}
                  checked={get(initialValues, acceptDigitalPath) === true}
                  {...field}
                  onChange={acceptDigitalField.onChange}
                  onBlur={acceptDigitalField.onBlur}
                />
              )}
            </FormField>
          </Col>
          <Col lg={24} xs={24}>
            <Alert
              showIcon
              type="info"
              message={SUBSCRIPTION.FORM.DIGITAL_OPTION.INFO_LMF_NOTE}
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Consents;
